export default {  

    end: "Your Farmer 4.0 Profile",

    profile: "YOUR PROFILE",

    restart: "Restart Quiz",

    submit: "submit",

    print: "Download your PDF profile",

    data: "YOUR DATA",

    progress: "Progress",

    confirm: {

        restart: 'Are you sure that you want to LOSE ALL YOUR DATA and restart the test?'

    },

    steps: {

        "0-1": "ASSESSMENT OF EDUCATIONAL LEVEL",

        "0-2": "ENTREPRENEURIAL experience in Agricolture",

        "1-1": "IDENTIFICATION OF THE PAST EXPERIENCES IN AGRICULTURE ",

        "1-2": "IDENTIFICATION OF THE PAST EXPERIENCES IN AGRICULTURE ",

        "1-3": "IDENTIFICATION OF THE PAST EXPERIENCES IN AGRICULTURE ",

        "1-4": "IDENTIFICATION OF THE PAST EXPERIENCES IN AGRICULTURE ",

        "2": "PROPENSITY TO ENTREPRENEURSHIP",

        "3-1": "SOFT SKILLS TO BE A SUCCESSFUL ENTREPRENEUR - CREATIVITY",

        "3-2": "SOFT SKILLS TO BE A SUCCESSFUL ENTREPRENEUR - COMMUNICATION PART 1",

        "3-3": "SOFT SKILLS TO BE A SUCCESSFUL ENTREPRENEUR - COMMUNICATION PART 2",

        "3-4": "SOFT SKILLS TO BE A SUCCESSFUL ENTREPRENEUR - COMMUNICATION PART 3",

        "3-5": "SOFT SKILLS TO BE A SUCCESSFUL ENTREPRENEUR - COMMUNICATION PART 4",

        "4-1": "ICT COMPETENCES - KEY COMPETENCES",

        "4-2-1": "ICT COMPETENCES - FARMER 4.0 COMPETENCES",

        "4-2-2": "ICT COMPETENCES - FARMER 4.0 COMPETENCES",

        "4-2-3": "ICT COMPETENCES - FARMER 4.0 COMPETENCES",

        "4-2-4": "ICT COMPETENCES - FARMER 4.0 COMPETENCES",

        "4-2-5": "ICT COMPETENCES - FARMER 4.0 COMPETENCES",

        "4-2-6": "ICT COMPETENCES - FARMER 4.0 COMPETENCES",

        "5-1": "OTHER PROFESSIONAL COMPETENCES TO BE A FARMER 4.0",

        "5-2": "OTHER PROFESSIONAL COMPETENCES TO BE A FARMER 4.0",

        "5-3": "OTHER PROFESSIONAL COMPETENCES TO BE A FARMER 4.0",

    },

    questions: {

        "0-1-1" : "Select your educational level", 

        "0-2-1" : "What is the field in which you are/you would like to be an entrepreneur in agricolture? ",

        "1-1-1" : "Do you have any previous experience in agriculture as an entrepreneur?",

        "1-2-1" : "Do you have other kind of experiences in the agricultural filed you wish to become an entrepreneur?",

        "1-3-1" : "What other previous experiences do you have in agriculture ?",

        "1-4-1" : "How long time did you spend in this position?",

        "1-4-2" : "How long has it been since you acquire this experience?",

        "2-1" : "I am willing to regularly work 50 hours or more per week. ",

        "2-2" : "My family will support my going into business. My family will support my wish to start a business.",

        "2-3" : "I am willing to accept both financial and work-related risks when necessary. ",

        "2-4" : "I don't need all the fringe benefits provided by regular employment (eg. pension contributions, paid holidays). ",

        "2-5" : "I am willing to take full responsibility for the successes and/or failures of my business.",

        "2-6" : "I will have more financial success by having my own business. The possibility of financial success is higher if I have my own business ",

        "2-7" : "I feel a great deal of pride when I complete a project successfully.",

        "2-8" : "I have a high-energy level that can be maintained over a long time. ",

        "2-9" : "I enjoy having control over my own work assignments and decisions that effect my work ",

        "2-10" : "I believe that I am responsible for my own successes and failures. ",

        "2-11" : "I have a strong desire to get positive results even if it takes a great deal of extra effort. ",

        "2-12" : "I have a good understanding of how to manage a business. ",

        "2-13" : "Simpler: I can act in situations, where things change rapidly. ",

        "2-14" : "One or both of my parents were entrepreneurs. ",

        "2-15" : "I believe that my abilities and skills are greater than those of most of my co-workers. Simpler: I believe that I have better abilities and skills than others I have worked with.",

        "2-16" : "People trust me and see me as honest and reliable. ",

        "2-17" : "I always try to complete every project I start, no matter what obstacles and difficulties I might come across ",

        "2-18" : "I am willing to do something even when other people laugh or criticize me for doing it. ",

        "2-19" : "I can make decisions quickly. ",

        "2-20" : "I have a good network of friends, professionals and business acquaintances. ",

        "3-1-1" : "When facing a problem at work, I like to find several possible alternative solutions",

        "3-1-2": "If I get a new task, I prefer to follow the instructions carefully to avoid any problems",

        "3-1-3": "When I see something strange and unusual I prefer not to get involved to avoid inconvenience", 

        "3-1-4": "In a discussion, I like to listen to the ideas of others, even if I do not have/share the same ideas them",

        "3-1-5": "When things are unclear, I ask for explanations to understand better",

        "3-1-6": "When I have to do repetitive work, I usually look for different ways to finish the task (either to find a faster method, a new method or to make sure that it is not useless) to do it faster, to do it in a new way, or even realize if I should not do it because it is useless)",

        "3-1-7": "I prefer to reason with logic and rationality, leaving out emotional and impulsive arguments",

        "3-1-8": "I love new challenges - they motivate me to do my best",

        "3-1-9": "I like to play with ideas",

        "3-1-10": "I agree with the statement: copying is useful because it allows innovation",

        "3-1-11": "In complex situations, I go to experts or those I see as experts",

        "3-1-12": "To convince others that my idea is right, I am willing to fight for, explain and prove the value of my idea",

        "3-1-13": "Anarchy, in small doses, is a strong tool for innovation",

        "3-1-14": "I start tasks without fully completing them",

        "3-1-15": "It is impossible to be creative in office work",

        "3-1-16": "If I change jobs, I prefer one with routine tasks or where I know which tasks I have to do",

        "3-1-17": "When there are complicated situations at work, I try not to think too much about it. Instead I use my intuition to find a solution",

        "3-1-18": "I do not believe that the managerial and accounting aspects of a task is important and would focus that attention on strategic priorities",

        "3-1-19": "I prefer the creative phase of a task because I can cooperate with others to produce new ideas",

        "3-1-20": "I prefer arts/humanities to natural /financial sciences",

        "3-1-21": "I am open to the fact that there can be alternative ways to reach the wanted result",

        "3-1-22": "Being innovative at work is a limitation. It is better to agree with the rest of the group",

        "3-1-23": "When I choose a restaurant or a bar, I prefer those I already know because I know what I will get",

        "3-1-24": "Even when there are serious and critical situations, I like to think that there is a possible solution. You just have to look for it. It does not help to lose hope",

        "3-1-25": "I know and apply methods and techniques to develop creativity at work",

        "3-2-1": "I can impress the person that speaks with me",

        "3-2-2": "The one who speaks the most is stronger in the discussion",

        "3-2-3": "I know how to get my ideas across",

        "3-2-4": "I feel comfortable in discussions",

        "3-2-5": "In a discussion there is always a winner and a loser",

        "3-2-6": "I am not afraid to embarrass the other person in the discussion",

        "3-2-7": "I am not afraid of anyone",

        "3-2-8": "I enjoy contradictions",

        "3-2-9": "It is necessary to be able to get angry",

        "3-2-10": "In a discussion I want to win",

        "3-3-1": "I usually defend my ideas with strong belief",

        "3-3-2": "I rarely get confused",

        "3-3-3": "I can defend an idea which I don't agree with",

        "3-3-4": "I try to understand what the other person is trying to achieve/the intention of another person",

        "3-3-5": "I feel comfortable asking for an explanation of an idea or I feel comfortable stating that I did not understand an idea",

        "3-3-6": "I am able to attract the attention of others and keep them engaged",

        "3-3-7": "I know that both me and the person I speak to can make mistakes",

        "3-3-8": "I strongly defend my ideas",

        "3-3-9": "I don't seek out conflicts, but I am not afraid of them",

        "3-3-10": "I can change my opinion without feeling manipulate",

        "3-4-1": "I often daydream",

        "3-4-2": "I often don't dare to speak even if I would like to",

        "3-4-3": "I prefer not to speak about my ideas  to certain people",

        "3-4-4": "Sometimes I forget what I was about to say when I speak",

        "3-4-5": "I do not like to get involved in conflict and try to avoid it",

        "3-4-6": "I often stay out of the discussion because I don't know how to defend my ideas",

        "3-4-7": "I feel better not being a part   of the debate instead of joining the fight",

        "3-4-8": "I wish I could express my needs with more strength",

        "3-4-9": "Even when I am asked, it is difficult to express myself in a clear way",

        "3-4-10": "I rarely speak first",

        "3-5-1": "I avoid conflicts because they don't lead to anything",

        "3-5-2": "I like to use conflicting and/or unexpected arguments",

        "3-5-3": "It is necessary to be able to discourage the one speaking",

        "3-5-4": "I let others speak to find out information about them",

        "3-5-5": "I am good at defending a point of view which I don't agree with",

        "3-5-6": "People can be persuaded more easily when complimented I am good at defending a point of view which I don't agree with",

        "3-5-7": "To speak first is an unnecessary risk",

        "3-5-8": "To cause an argument between the other people in the discussion is a good way to gain control of a situation",

        "3-5-9": "I know how to hide my ideas",

        "3-5-10": "To cause an argument between the other people in the discussion is a good way to gain control of a situation when I think others don't agree with them",

        "4-1-1": "Using a word processing programme, eg. Word, Pages, Writer, Google Docs etc.",

        "4-1-2": "Using a spreadsheet programme, eg. Excel, Numbers, Calc, Google Sheets, etc.",

        "4-1-3": "Using the internet to find information",

        "4-1-4": "Using communication tools and social media, eg. email, Facebook, LinkedIN",

        "4-2-1": "Are you able to work in CAD?",

        "4-2-2": "Are you able to work in CAE?",

        "4-2-3": "Are you able to work in CAM?",

        "4-2-4": "Are you able to work in RE?",

        "4-2-5": "Are you able to work in the field of additive manufacturing?",

        "4-2-6": "Are you able to use social media (i.e. facebook, Instagram, Pinterest...) or a web site for introducing yourself and your farm/activities or sell your products?",

        "5-1": "Do you know how to create a network of \"digital farmers\" following the rules of the GDPR and how to adopt an appropriate governance model of your farm based on the concept of FABLAB, introducing 4.0 technologies?",

        "5-2": "Are you expert in the internationalization of your business?",

        "5-3": "Do you know the \"sustainable agriculture\" and do you practice it?",

    },

    answers: {

        "yes": "yes",

        "no": "no",

        "s_agree" : "Strongly Agree",

        "agree": "Agree",

        "sw_agree": "Somewhat Agree",

        "disagree" : "Disagree",

        "s_disagree": "Strongly Disagree",

        "never": "Never",

        "rarely": "Rarely",

        "often": "Often",

        "always": "Always",

        "true": "True",

        "false": "False",

        "insecure": "I am insecure and need help to use this type of tool",

        "confident": "I feel fairly confident and I usually find the solutions myself when using this tool",

        "indipendent": "I work independently and confident and I am able to teach others how to use this tool",

        "dontknow": "I don't know",   

        "0-1-1-0": "No education",

        "0-1-1-1": "Lower secondary school diploma",

        "0-1-1-2": "Compulsory education certificate",

        "0-1-1-3": "Professional certificate",

        "0-1-1-4": "High School Diploma",

        "0-1-1-5": "IFTS or ITS certificate",

        "0-1-1-6": "Bachelor's Degree or First level Post Graduate Diploma",

        "0-1-1-7": "Master's degree or Secondary level Post Graduate Diploma",

        "0-1-1-8": "Research Doctorate - PhD",

        "0-2-1-11": "Growing of cereals (except rice), leguminous crops and oil seeds ", 

        "0-2-1-12": "Growing of rice ", 

        "0-2-1-13": "Growing of vegetables and melons, roots and tubers ",

        "0-2-1-14": "Growing of sugar cane ", 

        "0-2-1-15": "Growing of tobacco ", 

        "0-2-1-16": "Growing of fibre crops ", 

        "0-2-1-17": "Growing of other non-perennial crops ", 

        "0-2-1-21": "Growing of grapes ", 

        "0-2-1-22": "Growing of tropical and subtropical fruits", 

        "0-2-1-23": "Growing of citrus fruits ", 

        "0-2-1-24": "Growing of citrus fruits ", 

        "0-2-1-25": "Growing of other tree and bush fruits and nuts ", 

        "0-2-1-26": "Growing of oleaginous fruits ", 

        "0-2-1-27": "Growing of beverage crops ", 

        "0-2-1-28": "Growing of spices, aromatic, drug and pharmaceutical crops ", 

        "0-2-1-29": "Growing of other perennial crops",  

        "0-2-1-30": "Plant propagation ", 

        "0-2-1-41": "Raising of dairy cattle ", 

        "0-2-1-42": "Raising of other cattle and buffaloes ", 

        "0-2-1-43": "Raising of horses and other equines", 

        "0-2-1-44": "Raising of camels and camelids ", 

        "0-2-1-45": "Raising of sheep and goats ", 

        "0-2-1-46": "Raising of swine/pigs ", 

        "0-2-1-47": "Raising of poultry ", 

        "0-2-1-48": "Raising of other animals ", 

        "0-2-1-50": "Mixed farming ", 

        "0-2-1-61": "Support activities for crop production ", 

        "0-2-1-62": "Support activities for animal production ", 

        "0-2-1-63": "Post-harvest crop activities ", 

        "0-2-1-64": "Seed processing for propagation ", 

        "0-2-1-70": "Hunting, trapping and related service activities", 

        "1-3-1-1" : "educational experience",

        "1-3-1-2" : "volunteer work",

        "1-3-1-3" : "other experiences",

        "1-4-1-1" : "less than 3 years",

        "1-4-1-2" : "more than 3 years",

    },

    results: {

        "1-1": "Even if you have already some previous experiences in agricolture as an entrepreneur, our FARMER 4.0 platform could help you to deep some important concepts for you success as 4.0 farmers. Anyway, how is your propensity to entrepreneurship and what about your entrepreneurial soft skills?",

        "1-2": "Since you have no experience as an entrepreneur in agriculture, it is important to understand first of all your propensity for entrepreneurship and if you need to acquire some technical or soft skills to be successful in the field you wish to work. At this regard we can say that ",

        "1-4": {

            score: {

                "0-1": "Even if you have done some other experiences (than professionals) in agriculture,  this kind of experiences could be not enough long (in term of time) or recent, so it is important to understand first of all your real propensity for entrepreneurship and if you own the right level of skills needed to be successful as 4.0 FARMER. At this regard we can say that ",

                "2" : "Even if you have done some recent and important other experiences (than professionals) in agriculture, you have not at all experience as entrepreneur so it is important to understand first of all your real propensity for entrepreneurship and if you own the right level of skills needed to be successful as 4.0 FARMER. At this regard we can say that "

            }

        },

        "2": {

            score: {

            "39": "You should probably avoid entrepreneurship. We suggest you an interview with an assessor to verify your real expectations.",

            "59": "Self-employment/entrepreneurship may not be an appropriate career for you. We suggest you an interview with an assessor to verify your real expectations.",

            "79" : "It seems that you have satisfactory abilities to be an entrepreneur.",

            "100": "It seems that you have outstanding abilities to be an entrepreneur.",

            }

        },

        "3-1": {

            score: {

            "44": "Creativity is for you an irritation. You do not see any opportunity in creativity. You avoid situations where you have to be creative. You prefer to work in a structured and logical way. You do not like situations that change a lot or the process of making decisions. If you want to be successful in the agriculture 4.0, we suggest you to improve your creativity (i.e. following a course on this soft skill or asking a help to a trainer/mentor).",

            "64": "Creativity for you is a duty. You prefer a job where you know which tasks to do, and where you rarely have to be creative. However, when the situation requires it, you are able to find alternative solutions. You can develop your creativity by being more flexible. If you want to be successful in the agriculture 4.0, we suggest you to improve your creativity (i.e. following a course on this soft skill or asking a help to a trainer/mentor).",

            "84" : "Creativity for you is necessary. Creativity is not a problem for you but often it is necessary. Doing things in new ways is a value and sometimes a necessity. You believe that sometimes the solution needs to be found in the not known. You are able to find a balance between fixed procedures and being open to alternatives. Be aware that you still have to be thorough when you do routine work. This is good for who wants to be successful in the agriculture 4.0.",

            "100": "Creativity for you is a pleasure. You have many ideas and you are always ready to find new inspiration, new ideas and new projects. You need to be in an environment that stimulates your creativity and fantasy, otherwise you get bored and do not feel valued enough. But please, pay attention: intuition is necessary, but not enough! This is good for who wants to be successful in the agriculture 4.0."

            }

        },

        "3-2": {

            score: {

            "2": "You are not very determined (in the short term) and that you exercise a lack of consistency to achieve your goals (in the medium to long term). This is not good for who wants to work as a successful entrepreneur in agriculture: in fact, one of the most important characteristics of entrepreneurs is determination. This trait is closely related to self-confidence. The more you believe in yourself, the more likely you are to continue to struggle for success when faced with tremendous obstacles. You need determination in order to overcome the problems that beset every new venture. Please, take into consideration to improve your capacity to be determined and consistent in achieving your objectives (i.e. following a course on these soft skills or asking help to a trainer/mentor).",

            "5": "You are not always determined (in the short term) and that occasionally you may not be consistent when trying to achieve your goals (medium to long term). This is not good for who wants to work as a successful entrepreneur in agriculture: in fact, one of the most important characteristics of entrepreneurs is determination. This trait is closely related to self-confidence. The more you believe in yourself, the more likely you are to continue to struggle for success when faced with tremendous obstacles. You need determination in order to overcome the problems that beset every new venture. Please, take into consideration to improve your capacity to be determined and consistent in achieving your objectives (i.e. following a course on these soft skills or asking help to a trainer/mentor).",

            "6" : "You are very determined (in the short term) and that you are very consistent when trying to achieve your goals (in the medium to long term). This is excellent for an entrepreneur in agriculture.",

            "9": "You have a slight tendency to devalue the action of other people and showing negative feelings towards the person acting rather than the action itself. This is not good for who wants to work as a successful entrepreneur in agriculture. Please, take into consideration to improve your capacity to be more collaborative with the others (i.e. following a course on these soft skills or asking help to a trainer/mentor).",

            "12": "In general, you show a tendency to devalue the action of other people and showing negative feelings towards the person acting rather than the action itself. This is not good for who wants to work as a successful entrepreneur in agriculture. Please, take into consideration to improve your capacity to be more collaborative with the others (i.e. following a course on these soft skills or asking help to a trainer/mentor).",

            }

        },

        "3-3": {

            score: {

            "2": "In general, you show a a strong tendency not to feel responsible of your actions: successful entrepreneurs have an internal locus of control or inner sense of responsibility for the outcome of a venture. To be an entrepreneur, you should have a strong sense of being a victor who is responsible for your actions. If, however, you often consider yourself a victim and blame other people, bad luck, or difficult circumstances for your failures, entrepreneurship might not be the right career move for you. We suggest you to work on this matter (i.e. following a course on these soft skills or asking help to a trainer/mentor).",

            "5": "In general, you show a moderate tendency to feel responsible of your actions: successful entrepreneurs have an internal locus of control or inner sense of responsibility for the outcome of a venture. To be an entrepreneur, you should have a strong sense of being a victor who is responsible for your actions. If, however, you often consider yourself a victim and blame other people, bad luck, or difficult circumstances for your failures, entrepreneurship might not be the right career move for you. We suggest you to work on this matter (i.e. following a course on these soft skills or asking help to a trainer/mentor).",

            "6" : "You show a sufficient tendency to feel responsible and therefore an equally sufficient propensity to commit yourself to achieve the goals: successful entrepreneurs have an internal locus of control or inner sense of responsibility for the outcome of a venture. To be an entrepreneur, you should have a strong sense of being a victor who is responsible for your actions. If, however, you often consider yourself a victim and blame other people, bad luck, or difficult circumstances for your failures, entrepreneurship might not be the right career move for you. We invite you to improve your assertiveness (i.e. following a course on these soft skills or asking help to a trainer/mentor).",

            "9": "You show a good tendency to feel responsible and therefore an equally good propensity to commit yourself to achieve the goals. This is good for who wants to be a successful entrepreneur in agriculture.",  

            "12": "You show your excellent tendency to feel responsible and therefore an equally excellent propensity to commit yourself to achieve the goals. This is excellent for who wants to be a successful entrepreneur in agriculture.",  

            }

        },

        "3-4": {

            score: {

            "2": "You may have a tendency to keep everything under control (lack of selective ability) and may confuse short term goals with long term goals which may result in being overwhelmed with deadlines. This situation has to be improved (i.e. following a course on these soft skills or asking help to a trainer/mentor) because entrepreneurs are risk takers. They risk their careers, time and money in order to make a success of their businesses. To be successful in self-employment, you should feel comfortable taking reasonable risks.",

            "5": "It may be difficult for you to prioritize goals and may not always be able to distinguish between very urgent and non-urgent matters. This can lead to very stressful situations. Entrepreneurs are risk takers. They risk their careers, time and money in order to make a success of their businesses. To be successful in self-employment, you should feel comfortable taking reasonable risks. This situation has to be improved (i.e. following a course on these soft skills or asking help to a trainer/mentor).",

            "6" : "You have a high ability in prioritizing goals and can distinguish between very urgent and non-urgent matters, how it is required to an entrepreneur.",

            "9": "You have a difficulty in completing your daily tasks and achieving your goals. By the way, entrepreneurs have a strong need for achievement. They strive to excel and accomplish objectives that are quite high. You should be willing to set high goals for yourself and enjoy striving to achieve those goals. Taking this thing into consideration, you have to improve your ability to (i.e. following a course on these soft skills or asking help to a trainer/mentor).",

            "12": "You have a difficulty in completing your daily tasks and achieving your goals. However, this situation can be improved (i.e. following a course on these soft skills or asking help to a trainer/mentor) because entrepreneurs are risk takers. They risk their careers, time and money in order to make a success of their businesses. To be successful in self-employment, you should feel comfortable taking reasonable risks.",

            }

        },

        "3-5": {

            score: {

            "2": "You have a strong ability to do-it-yourself, without any help from other people and to act on your own leadership/initiative/drive. But sometimes it is necessary to consult other professionals for advice, information, and referrals if you want to reach the success. So, we suggest you to improve your ability to reach your professional objectives involving other interlocutors.",

            "5": "You have an average ability to work on your own initiative/drive/ability without asking help from others. But sometimes this could be not enough. So, we suggest you to improve your ability to reach your professional objectives involving other interlocutors.",

            "6" : "You are very much able work on your own initiative/ability/drive but also know when to accept help from other people and this is excellent for someone like you who wants to reach professional objectives involving other interlocutors.",

            "9": "While you have an average ability to assign tasks, you sometimes depend on help from others and a lot of information to support your decision too much. So, we suggest you to improve your ability to reach your professional objectives involving other interlocutors without arriving to their manipulation. ",

            "12": "While you are very able to assign tasks, you tend to ask for too much help and look for too much information to support your decisions and this could. So, we suggest you to improve your ability to reach your professional objectives involving other interlocutors without arriving to their manipulation.",

            }

        },

        "4-1": {

            score: {

            "5": "If you want to be able to use FARMER 4.0 tools, you have to expand/broaden/develop your general ICT knowledge following a course (at least basic level).",

            "8": "If you want to be able to use properly FARMER 4.0 tools, you could improve your knowledge following a course (medium level).",

            "10" : "Congratulations: your general ICT knowledge is advanced and you wouldn't have to have any problem in using FARMER 4.0 tools and models.",

            }

        },

        

        "4-2-1": {

            "yes":"Even if you are already able to work in CAD, we invite you to take a look at CAD/CAM/CAE/RE module on FARMER 4.0 platform.",

            "no": "You are required to follow the CAD module on FARMER 4.0 platform",

        },

        "4-2-2": {

            "yes": "Even if you are already able to work in CAE, we invite you to take a look at CAD/CAM/CAE/RE module on FARMER 4.0 platform.",

            "no": "You are required to follow the CAE module on FARMER 4.0 platform.",

        },

        "4-2-3": {

            "yes": "Even if you are already able to work in CAM, we invite you to take a look at CAD/CAM/CAE/RE module on FARMER 4.0 platform.",

            "no": "You are required to follow the CAM module on FARMER 4.0 platform.",

        },

        "4-2-4": {

            "yes": "Even if you are already able to work in RE, we invite you to take a look at CAD/CAM/CAE/RE module on FARMER 4.0 platform.",

            "no": "You are required to follow the RE module on FARMER 4.0 platform.",

        },

        "4-2-5": {

            "yes": "Even if you are already able to work in additive manufacturing, we invite you to take a look at Additive Manufacturing - 3D Print module on FARMER 4.0 platform.",

            "no": "You are required to follow the Additive Manufacturing - 3D Print module on FARMER 4.0 platform.",

        },

        "4-2-6": {

            "yes": "Even if you are already able to use social media (i.e. facebook, Instagram, Pinterest...) or a web site for introducing yourself and your farm/activities or sell your products, we invite you to take a look at the \"Social Networking for the Global Farm 4.0\" and \"On line communication tools and techniques\" modules on the FARMER 4.0 platform.",

            "no": "You are required to follow the \"Social Networking for the Global Farm 4.0\" and \"On line communication tools and techniques\" modules on the FARMER 4.0 platform.",

        },

        "5-1": {

            "yes": "Even if you are already able to work with a fablab approach and you know very well the digitalization in agriculture, we invite you to take a look at \"Agricultural Entrepreneurship based on the FabLab approach\" module on FARMER 4.0 platform.",

            "no": "You are required to follow the \"Agricultural Entrepreneurship based on the FabLab approach\" module on FARMER 4.0 platform.",

        },

        "5-2": {

            "yes": "Even if you are already able to work in an international context, we invite you to take a look at \"Internationalization and sustainability of the Global Farm 4.0\" module on FARMER 4.0 platform.",

            "no": "You are required to follow the \"Internationalization and sustainability of the Global Farm 4.0\" module on FARMER 4.0 platform",

        },

        "5-3": {

            "yes": "Even if you work for the sustainability of the agriculture, we invite you to take a look at \"Internationalization and sustainability of the Global Farm 4.0\" module on FARMER 4.0 platform.",

            "no": "You are required to follow the \"Internationalization and sustainability of the Global Farm 4.0\" module on FARMER 4.0 platform."

        }

    }

}

